import getWrappedUseMutation from "api/helpers/getWrappedUseMutation";
import apiClient from "api-client";

export const useCreateTimeslotMutation = getWrappedUseMutation(apiClient.TimeSlot.post);

export const useUpdateTimeslotMutation = getWrappedUseMutation(apiClient.TimeSlot.put);

export const useDeleteTimeslotMutation = getWrappedUseMutation(apiClient.TimeSlot.delete);
